module.exports = __webpack_public_path__ + "media/images/footer/mail-footer-6575c2f1b1b7fa769c380c5d89cf8719.svg";